<template>
  <div>
    <section class="main-content">

        <div class="main-block main-block-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-articles bck-views">
                            <h2 class="title">
                                <span>創造永遠美好回憶，值得花時間了解、選擇</span>
                                <span class="sub-title">婚禮歌曲魔力無窮，聆聽獨特愛情印記</span>
                            </h2>
                            <article class="article-editor">
                              <p>一場真正的婚宴起始於求婚應允，接著開始籌備婚禮。</p>
                              <!-- <p>婚禮中的種種環節，一一展開；充滿期待的賓客入席、感人熱淚的一次進場、新人誓言相守、證婚、主婚致詞、進餐、愉快開心的二次進場、
                                愛情回顧、賓客互動遊戲、獻唱、敬酒、祝福感謝所有參加婚禮的人、歡送賓客，到新人踏上蜜月旅途畫上完美的句點。
                                這種種的環結都有著不同的情緒，新人可依據自己的偏好，選擇在哪一個環節用婚禮歌曲創造自己獨特的美好時刻。</p> -->
                              <p>我們針對婚禮流程中的&#60;求婚/迎賓&#62;、&#60;新人進場&#62;、&#60;愛情回顧&#62;、&#60;婚宴配樂&#62;、&#60;送客/蜜月&#62;，分別精心挑選婚禮歌曲和音樂、介紹每首婚禮歌曲，
                                並附上曾經使用過該婚禮歌曲的婚禮 video，希望每對新人或婚禮顧問，都能找到專屬於自己和伴侶一生回味無窮的婚禮歌曲。  </p>
                              <p>除此之外，我們也為了想要有個主題式婚禮的新人，花費時間尋找歌詞內涵、歌曲旋律、歌曲數量皆有一定分量的歌者，
                                讓整場婚禮都能有著一致的調性，如單一歌者、歌曲風格、婚禮氣氛等，這個分類命名為&#60;主題歌曲&#62;，將會陸續推出不同主題的婚禮歌曲推薦。</p>
                            </article>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-music"><span>精選分類</span></h3>
                            <div class="articles-items">
                                <div class="row">
                                    <div class="col-lg-4 col-md-6" v-for="(row, index) in songCategory">
                                        <div class="articles-box catalog-box">
                                            <a :href="'/topic'" v-if="row.id==6">
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+row.image_path" />
                                                </figure>
                                                <div class="text">
                                                    <h5 class="title">{{ row.title }}</h5>
                                                    <article class="article-editor" v-html="row.context"></article>
                                                </div>
                                            </a>
                                            <a :href="'/songCategory/'+row.id" v-else>
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+row.image_path" />
                                                </figure>
                                                <div class="text">
                                                    <h5 class="title">{{ row.title }}</h5>
                                                    <article class="article-editor" v-html="row.context"></article>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'songscatalog',
  data () {
    return {
      category: []
    }
  },
  mounted: function () {
  },
  computed: {
    ...mapGetters({
      songCategory: 'getSongCategory'
    })
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// SongsCatalog.vue?625e0f74